import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import {
  exchangeCodeForToken,
  isLogoutInProgress,
  markLoggedOut,
} from "./oidc";
import { clearAccessToken, setAccessToken } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export function OIDCCallbackPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const { t } = useI18n();

  useEffect(() => {
    async function run() {
      if (isLogoutInProgress()) {
        clearAccessToken();
        markLoggedOut();
        window.location.replace("/logged-out");
        return;
      }

      const code = params.get("code");
      const state = params.get("state");
      const expectedState = sessionStorage.getItem("oidc_state");
      if (!code || !state || state !== expectedState) {
        setError(t("oidc.callbackInvalid"));
        return;
      }
      try {
        const tokens = await exchangeCodeForToken(code);
        if (import.meta.env.VITE_OIDC_ENABLED !== "true") {
          setAccessToken(tokens.access);
        }
        if (import.meta.env.VITE_OIDC_ENABLED !== "true" && tokens.refresh) {
          localStorage.setItem("refresh_token", tokens.refresh);
        }
        if (import.meta.env.VITE_OIDC_ENABLED !== "true" && tokens.id_token) {
          localStorage.setItem("oidc_id_token", tokens.id_token);
          sessionStorage.setItem("oidc_id_token", tokens.id_token);
        }
        sessionStorage.removeItem("oidc_state");
        sessionStorage.removeItem("oidc_nonce");
        sessionStorage.removeItem("oidc_code_verifier");
        sessionStorage.removeItem("oidc_org_id");
        window.location.replace("/");
      } catch {
        setError(t("oidc.signInFailed"));
      }
    }
    void run();
  }, [params, t]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50">
      {error ? (
        <div className="text-destructive text-sm">{error}</div>
      ) : (
        <Loader2 className="text-primary h-8 w-8 animate-spin" />
      )}
    </div>
  );
}
